if (!customElements.get('az-marquee-control')) {
  class AzMarqueeControl extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.track = document.getElementById(this.getAttribute('target'));
      if (!this.button || !this.track) return;
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const paused = this.track.classList.toggle('is-paused');
      this.button.setAttribute('aria-pressed', String(paused));
      this.button.textContent = paused
        ? this.getAttribute('label-play')
        : this.getAttribute('label-pause');
    }
  }

  customElements.define('az-marquee-control', AzMarqueeControl);
}
